import * as dayjs from 'dayjs';
import { CartaoCredito } from './cartao-credito.model';
import { Credito } from './credito.model';
import { Pagamento } from './pagamento.model';
import { Status } from './status.model';
import { Account } from './account.model';

export interface IBeneficiados {
  compraId: number;
  userId: number;
  venda: number;
  quantidade: number;
  firstName: string;
  lastName: string;
}

export interface ICompra {
  id?: number;
  timestamp?: dayjs.Dayjs | null;
  valorCredito?: number | null;
  valorTotal?: number | null;
  quantidade?: number | null;
  statusCompra?: Status | null;
  cartaoCredito?: CartaoCredito | null;
  descricao?: string | null;
  creditos?: Credito[] | null;
  pagamento?: Pagamento | null;
  certificadoAutomatico?: string | null;
  nomeDestinatario?: string | null;
  cpfCnpjDestinatario?: string | null;
  user?: Account | null;
}

export class Compra implements ICompra {
  constructor(
    public id?: number,
    public timestamp?: dayjs.Dayjs | null,
    public valorCredito?: number | null,
    public valorTotal?: number | null,
    public quantidade?: number | null,
    public statusCompra?: Status | null,
    public cartaoCredito?: CartaoCredito | null,
    public descricao?: string | null,
    public creditos?: Credito[] | null,
    public pagamento?: Pagamento | null,
    public certificadoAutomatico?: string | null,
    public nomeDestinatario?: string | null,
    public cpfCnpjDestinatario?: string | null,
    public user?: Account | null
  ) { }
}

export function getCompraIdentifier(compra: ICompra): number | undefined {
  return compra.id;
}
